'use strict';

import * as _ from 'lodash';
import moment from 'moment';

const angular = require('angular');
const uiRouter = require('angular-ui-router');
import uiBootstrap from 'angular-ui-bootstrap';

export class ShareWithUsersController {
  /*@ngInject*/
  constructor($scope, $http, $uibModalInstance, app) {  
    $scope.isLoading = false;
    $scope.app = app;
    $scope.users = app.usersToShare.map(x => {
      return { id: x.id, email: x.email, selected: false };
    });         
    
    $scope.close = () => {
      $uibModalInstance.close(null);
    };

    $scope.save = () => {
      const data = $scope.users.filter(x => x.selected);

      if(data.length > 0) {
        $scope.isLoading = true;
        $http.post(`/api/applications/${$scope.app.id}/share`, data).then(res => {
          $uibModalInstance.close(res.data);
        });
      }      
    };
  }
}

ShareWithUsersController.$inject = ['$scope', '$http', '$uibModalInstance', 'app'];

export class EditOAuthController {
    constructor($scope, $http, $uibModalInstance, oauth) {  
      $scope.oauth = {
        corsOrigins: _.join(oauth.corsOrigins, '\n'),
        redirectUrls: _.join(oauth.redirectUrls, '\n'),
      };    
      
      $scope.close = () => {
        $uibModalInstance.close(null);
      };
  
      $scope.save = () => {
        const data = {
          applicationId: oauth.applicationId,
          id: oauth.id,
          enabled: true,
          type: 'public',
          secret: oauth.secret,
          redirectUrls: _.split($scope.oauth.redirectUrls, '\n'),
          corsOrigins: _.split($scope.oauth.corsOrigins, '\n'),
          cert: ''
        };
        $http.put(`/api/applications/${data.applicationId}/oauth/${oauth.id}`, data).then(res => {
          $uibModalInstance.close(res.data);
        });
      };
    }
  }
  
  EditOAuthController.$inject = ['$scope', '$http', '$uibModalInstance', 'oauth'];

  export class AddOAuthController {
    constructor($scope, $http, $uibModalInstance, app) {  
      $scope.oauth = {
        corsOrigins: '*',
        redirectUrls: ''
      };  
      $scope.newOAuth = true;  
      
      $scope.close = () => {
        $uibModalInstance.close(null);
      };
  
      $scope.create = () => {
        const data = {
          applicationId: app.id,
          enabled: true,
          type: 'public',
          redirectUrls: _.split($scope.oauth.redirectUrls, '\n'),
          corsOrigins: _.split($scope.oauth.corsOrigins, '\n'),
          cert: ''
        };
        $http.post(`/api/applications/${app.id}/oauth`, data).then(res => {
          $uibModalInstance.close(res.data);
        });
      };
    }
  }

  AddOAuthController.$inject = ['$scope', '$http', '$uibModalInstance', 'app'];

  export class DeleteOauthController {
   constructor($scope, $http, $uibModalInstance, oauth) {
     $scope.oauth = oauth;
     $scope.close = () => {
      $uibModalInstance.close(null);
     };
  
     $scope.delete = () => {
      $http.delete(`/api/applications/${oauth.applicationId}/oauth/${oauth.id}`).then(res => {
        $uibModalInstance.close($scope.oauth);
      });
     };
   }
  }
 
  DeleteOauthController.$inject = ['$scope', '$http', '$uibModalInstance', 'oauth'];

  export class ShowSecretController {
   constructor($scope, $http, $uibModalInstance, oauth) {
     $scope.oauth = oauth;
     $scope.close = () => {
      $uibModalInstance.close($scope.oauth);
     };
  
     $scope.regenerate = () => {
      $http.put(`/api/applications/${oauth.applicationId}/oauth/${oauth.id}/newsecret`, $scope.oauth).then(res => {
        $scope.oauth = res.data;
      });
     };
   }
  }

  ShowSecretController.$inject = ['$scope', '$http', '$uibModalInstance', 'oauth'];

  export class ConfirmDeleteAppController {
   constructor($state, $scope, $http, $uibModalInstance, app) {
     $scope.app = app;
  
     $scope.delete = () => {
       $http.delete(`/api/applications/${$scope.app.id}`).then(res => {
        $uibModalInstance.close($scope.oauth);
        $state.go('apps');
       });
     };
  
     $scope.close = () => {
      $uibModalInstance.close($scope.oauth);
     };
   }
  }

  ConfirmDeleteAppController.$inject = ['$state', '$scope', '$http', '$uibModalInstance', 'app'];


// WEBPACK FOOTER //
// ./client/app/application/application.modals.js